import React from 'react'

const CallQueries = () => {
  return (
    <div>
              <iframe
        src={"https://ucg.inaipi.me/InaipiCallRecording/Login.aspx?UserName=NWSupervisor&Password=Sample@123"}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  )
}

export default CallQueries